<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">

                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>预测信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="预测编码" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.id" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="国家名称" class="h-elformWrap-2">
                                                <brselect placeholder="请选择"
                                                          category="YLCountry_agent"
                                                          :v="saveData.country"
                                                          disabled
                                                          clearable
                                                          v-model="saveData.country">
                                                </brselect>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.proCode" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-tooltip  placement="top" :content="saveData.proModel" :disabled="isshowtip">
                                                    <el-input class="h-tableInput" v-model="saveData.proModel"  @mouseover.native="inputOnMouseOver($event)" disabled></el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.factory" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品类型" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.protype" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="规格型号" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.oemDesc" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="数量" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.proNumber" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="可用数量" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.useNumber" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="使用库存数量" v-if="showIn" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.useInventory"
                                                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"></el-input>
                                            </el-form-item>
                                            <el-form-item label="使用已预测单号" class="h-elformWrap-2" v-if="saveData.isOther=='1' && saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)">
                                                <el-input class="h-tableInput" v-model="saveData.useId" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="使用他人已预测单号" class="h-elformWrap-2" v-if="saveData.isOther=='2' && saveData.isSpecific=='2' && (saveData.isScheduling == '' || saveData.isScheduling == null)">
                                                <el-input class="h-tableInput" v-model="saveData.otherUseId" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="使用已预测库存" class="h-elformWrap-2" v-if="k == 1">
                                                <el-input class="h-tableInput" v-model="saveData.useId" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="发货方式" class="h-elformWrap-2">
                                                <el-select class="h-tableInput" v-model="saveData.deliveryMethod" disabled>
                                                    <el-option value="1" label="直发"></el-option>
                                                    <el-option value="2" label="库发"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="是否实单" class="h-elformWrap-2">
                                                <el-select class="h-tableInput" v-model="saveData.isReal" disabled>
                                                    <el-option value="1" label="实单"></el-option>
                                                    <el-option value="0" label="备货"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="预计交货时间" class="h-elformWrap-2">
                                                <el-input class="h-tableInput" v-model="saveData.deliveryDate" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2">
                                                <el-input v-model="saveData.remark" placeholder="备注" class="h-tableInput" disabled></el-input>
                                            </el-form-item>
                                            <!-- 附件上传 -->
                                            <el-form-item v-if="this.lkFlag" prop="fileUrl" label="方案图纸" class="h-elformWrap-2">
                                                <brupload
                                                        :refid="saveData.id"
                                                        reftype="WXYC_LKFJ"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item v-if="this.lkFlag" prop="fileUrl" label="施工确认单" class="h-elformWrap-2">
                                                <brupload
                                                        :refid="saveData.id"
                                                        reftype="WXYC_SGQRD"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="海尔标准配置" class="h-elformWrap-2" v-if="this.lkFlag" >
                                                <el-select class="h-tableInput" v-model="saveData.isStandard" disabled placeholder="请选择">
                                                    <el-option value="1" label="是"></el-option>
                                                    <el-option value="2" label="否"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item v-if="this.lkFlag" prop="fileUrl" label="投标参数" class="h-elformWrap-2">
                                                <brupload
                                                        :refid="saveData.id"
                                                        reftype="WXYC_TBCS"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="预排单号" class="h-elformWrap-2" v-if="saveData.protype=='自产' && (saveData.isOther == '' || saveData.isOther == null)">
                                                <el-input v-model="saveData.ypIds" class="h-tableInput" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="常规或改制" class="h-elformWrap-2">
                                                <brselect category="shifou_dingzhi" :v="saveData.isSpecific"
                                                          v-model="saveData.isSpecific" placeholder="请选择" disabled class="h-tableInput"/>
                                            </el-form-item>
                                            <el-form-item label="改制大类" class="h-elformWrap-2" required="" v-if="saveData.isSpecific == '2' && saveData.specificReq">
                                                <el-input v-model="saveData.specificReq"
                                                          disabled=""
                                                          class="h-tableInput" placeholder="描述"></el-input>
                                            </el-form-item>
                                            <el-form-item label="改制要求" class="h-elformWrap-2" v-if="saveData.isSpecific == '2' && saveData.specificReform">
                                                <el-input v-model="saveData.specificReform"
                                                          disabled=""
                                                          placeholder="改制要求"
                                                          class="h-tableInput">
                                                </el-input>
                                            </el-form-item>
                                            <el-form-item label="总单台加价(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                                                <el-input placeholder="请输入..." v-model="saveData.reformPriceRmb" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="占用预测单类型" class="h-elformWrap-2" v-if="saveData.isSpecific=='2' && (saveData.ypIds == '' || saveData.ypIds == null)" >
                                                <el-select class="h-tableInput" v-model="saveData.isOther" disabled placeholder="请选择">
                                                    <el-option value="" label=""></el-option>
                                                    <el-option value="1" label="自己"></el-option>
                                                    <el-option value="2" label="他人"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="占用改制加价(元)" class="h-elformWrap-2" v-if="saveData.isSpecific == '2'">
                                                <el-input placeholder="请输入..." v-model="saveData.otherYcReformPrice" disabled=""></el-input>
                                            </el-form-item>

                                            <el-form-item label="改制类型" class="h-elformWrap-2" required=""  v-if="saveData.isSpecific=='2' ">
                                                <el-select class="h-tableInput" v-model="saveData.isReformStock" disabled>
                                                    <el-option value="0" label="生产改制"></el-option>
                                                    <el-option value="1" label="库存改制"></el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item label="生产版本" class="h-elformWrap-2" prop="reformEdition" v-if="saveData.isSpecific=='2' ">
                                                <brselect disabled category="gaizhi_edition_wx" :v="saveData.reformEdition" disabled v-model="saveData.reformEdition"/>
                                            </el-form-item>
                                            <el-form-item label="生产日期" class="h-elformWrap-2" v-if="saveData.isSpecific=='2'">
                                                <el-input class="h-tableInput" v-model="saveData.produceTime" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="毛利率" class="h-elformWrap-2" prop="grossProfitRate" v-show="!this.cwUpdateFlag && this.saveData.grossProfitRate">
                                                <el-input  v-model="saveData.grossProfitRate" ></el-input>
                                            </el-form-item>
                                            <div style="margin-top: 10px;" v-if="saveData.isSpecific == '2'">

                                                <div v-for="(listIt, index) in saveData.specificList" :key="index" class="h-formBox">

                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制目录{{index+1}}
                                                        </template>
                                                        <el-input  v-model="saveData.specificList[index].specificDivision" readonly ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制要求{{index+1}}
                                                        </template>
                                                        <el-input  v-model="saveData.specificList[index].specificReform" readonly  ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            改制备注{{index+1}}
                                                        </template>
                                                        <el-input  type="textarea" autosize v-model="saveData.specificList[index].specificRemark" readonly ></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台改制数量{{index+1}}
                                                        </template>
                                                        <el-input placeholder="请输入改制数量" v-model="saveData.specificList[index].reformNum" readonly></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" v-if="index == 0 && saveData.specificList[index].reformPriceJs != null">
                                                        <template slot="label">
                                                            系统单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="系统单台加价" v-model="saveData.specificList[index].reformPriceJs" disabled></el-input>
                                                    </el-form-item>
                                                    <el-form-item  class="h-elformWrap-3" >
                                                        <template slot="label">
                                                            单台加价{{index+1}}
                                                        </template>
                                                        <el-input placeholder="单台加价" v-model="saveData.specificList[index].reformPrice" :readonly="cwUpdateFlag"></el-input>
                                                    </el-form-item>
                                                </div>
                                            </div>
                                            <div class="N-chan" v-if="afterXhFlag">
                                                <div class="h-pieceTitle2">
                                                    <h1>改制确认</h1>
                                                </div>
                                                <div class="h-pieceCon2">
                                                    <div class="h-formLine Yangbiao">
                                                        <el-form-item label="产值(元)" class="h-elformWrap-2" prop="outputValue">
                                                            <el-input v-model="saveData.outputValue" placeholder="请输入" :readonly="saveData.isgy === false">
                                                            </el-input>
                                                        </el-form-item>
                                                        <el-form-item label="标准台" class="h-elformWrap-2" prop="standardTable">
                                                            <el-input v-model="saveData.standardTable" placeholder="请输入" :readonly="saveData.isgy === false">
                                                            </el-input>
                                                        </el-form-item>
                                                    </div>
                                                </div>
                                                <div class="h-pieceCon2">
                                                    <div class="h-formLine Yangbiao">
                                                        <div v-for="(listIt, index) in saveData.individualizeList" :key="index" class="h-formBox">
                                                            <el-form-item  class="h-elformWrap-35" >
                                                                <template slot="label">
                                                                    个性化定制标准描述{{index+1}}
                                                                </template>
                                                                <el-input placeholder="由型号经理填写" v-model="saveData.individualizeList[index]" readonly></el-input>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="h-pieceCon2">
                                                    <div class="h-formLine Yangbiao">
                                                        <div v-for="(listIt, index) in saveData.logoRequestList" :key="index" class="h-formBox">
                                                            <el-form-item  class="h-elformWrap-35" >
                                                                <template slot="label">
                                                                    包装标识要求{{index+1}}
                                                                </template>
                                                                <el-input placeholder="由型号经理填写" v-model="saveData.logoRequestList[index]" readonly></el-input>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="h-pieceCon2">
                                                    <div class="h-formLine Yangbiao">
                                                        <el-form-item label="物料工位" class="h-elformWrap-5" prop="stationlist" >
                                                            <el-checkbox-group v-model="saveData.stationlist" disabled>
                                                                <el-checkbox v-for="item in options" :label="item.code" :key="item.code" >{{item.name}}</el-checkbox>
                                                            </el-checkbox-group>
                                                        </el-form-item>
                                                        <el-form-item label="检测要求" class="h-elformWrap-5" prop="checkRequest">
                                                            <el-input type="textarea" placeholder="请输入检测要求" autosize v-model="saveData.checkRequest" readonly></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="涉及主关件变更的测试计划及测试报告" class="h-elformWrap-5">
                                                            <brupload
                                                                    :refid="saveData.id"
                                                                    reftype="改制明细测试报告"
                                                                    :uploadflag="false"
                                                                    :delflag="false"
                                                                    :showtime="false"
                                                            >
                                                            </brupload>
                                                        </el-form-item>
                                                    </div>
                                                </div>

                                            </div>

                                            <el-table
                                                    ref="multipleTable"
                                                    :data="saveData.reformMainDetailList"
                                                    border
                                                    v-if="afterXhFlag"
                                                    style="width: 100%">
                                                <el-table-column label="个性化改制物料明细">
                                                    <el-table-column
                                                            prop="orderby"
                                                            label="序号"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            {{scope.row.orderby}}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="materialName"
                                                            label="物料描述"
                                                            :show-overflow-tooltip="true"
                                                            width="130">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.materialName}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="materialCode"
                                                            label="物料专用号"
                                                            width="90">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.materialCode}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="purchaseGroup"
                                                            label="采购组"
                                                            width="80">
                                                        <template slot-scope="scope">
                                                            {{scope.row.purchaseGroup}}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="materialOrder"
                                                            label="物料单耗"
                                                            width="90">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.materialOrder}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="unit"
                                                            label="单位"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.unit}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="numbermb"
                                                            label="模板导入数量"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.numbermb}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="numberjs"
                                                            label="系统计算数量"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.numberjs}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="number"
                                                            label="最终使用数量"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.number}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="sapNetpr"
                                                            v-show="!this.cwUpdateFlag"
                                                            label="sap采购价"
                                                            width="100">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.sapNetpr}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="isSelf"
                                                            label="自制/外购"
                                                            width="90"
                                                            :show-overflow-tooltip="true">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                <div v-if="scope.row.isSelf == 0">外购</div>
                                                                <div v-if="scope.row.isSelf == 1">自制</div>
                                                                <div v-if="scope.row.isSelf == 2">外购-厂家改制</div>
                                                                <div v-if="scope.row.isSelf == 3">外购-到厂改制</div>
                                                            </div>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column
                                                            prop="remark"
                                                            label="备注"
                                                            :show-overflow-tooltip="true"
                                                            width="200">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.remark}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="supplierName"
                                                            label="供应商名称"
                                                            :show-overflow-tooltip="true"
                                                            width="100">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.supplierName}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                            label="图纸"
                                                            :show-overflow-tooltip="true"
                                                            fixed
                                                            min-width="150">
                                                        <template slot-scope="scope">
                                                            <brupload
                                                                    :refid="scope.row.id"
                                                                    reftype="改制物料明细"
                                                                    :showtime="false">
                                                            </brupload>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="changeDes"
                                                            label="变更描述"
                                                            :show-overflow-tooltip="true"
                                                            width="200">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.changeDes}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>

                                                </el-table-column>
                                                <el-table-column label="替换物料明细">
                                                    <el-table-column
                                                            prop="materialNameTh"
                                                            label="物料描述"
                                                            :show-overflow-tooltip="true"
                                                            width="130">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.materialNameTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="materialCodeTh"
                                                            label="物料专用号"
                                                            width="90">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.materialCodeTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="unitTh"
                                                            label="单位"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.unitTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                   <!-- <el-table-column
                                                            prop="numbermbTh"
                                                            label="模板导入数量"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.numbermbTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="numberjsTh"
                                                            label="系统计算数量"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.numberjsTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>-->
                                                    <el-table-column
                                                            prop="numberTh"
                                                            label="最终使用数量"
                                                            width="50">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.numberTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="sapNetprTh"
                                                            v-show="!this.cwUpdateFlag"
                                                            label="sap采购价"
                                                            width="100">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.sapNetprTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="remarkTh"
                                                            label="备注"
                                                            :show-overflow-tooltip="true"
                                                            width="200">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.remarkTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="supplierNameTh"
                                                            label="供应商名称"
                                                            :show-overflow-tooltip="true"
                                                            width="200">
                                                        <template slot-scope="scope">
                                                            <div>
                                                                {{scope.row.supplierNameTh}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>

                                                    <el-table-column
                                                            label="图纸"
                                                            :show-overflow-tooltip="true"
                                                            fixed
                                                            min-width="150">
                                                        <template slot-scope="scope">
                                                            <brupload
                                                                    :refid="scope.row.id"
                                                                    reftype="替换物料明细"
                                                                    :showtime="false">
                                                            </brupload>
                                                        </template>
                                                    </el-table-column>

                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div v-if="ycTable.length > 0" style="width: 95%">
                                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                <h1>占用预测库存信息</h1>
                                            </div>
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="ycTable"
                                                    stripe
                                                    border
                                                    max-height="500"
                                                    style="width: 100%;margin-left: 2%">
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="id"
                                                        width="160"
                                                        :show-overflow-tooltip="true"
                                                        label="预测编码">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="country"
                                                        width="90"
                                                        :show-overflow-tooltip="true"
                                                        label="国家名称">
                                                    <template slot-scope="scope">
                                                        <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proModel"
                                                        width="140"
                                                        :show-overflow-tooltip="true"
                                                        label="型号">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proCode"
                                                        width="120"
                                                        :show-overflow-tooltip="true"
                                                        label="产品编码">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="protype"
                                                        width="90"
                                                        label="型号属性"
                                                        :show-overflow-tooltip="true">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proNumber"
                                                        width="60"
                                                        :show-overflow-tooltip="true"
                                                        label="数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="useNumber"
                                                        :show-overflow-tooltip="true"
                                                        width="100"
                                                        label="可录单数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="useInventory"
                                                        width="120"
                                                        :show-overflow-tooltip="true"
                                                        label="使用库存数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="stockStatus"
                                                        width="90"
                                                        label="库存状态">
                                                    <template slot-scope="scope">
                                                        <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isSpecific"
                                                        width="110"
                                                        :show-overflow-tooltip="true"
                                                        label="常规或改制">
                                                    <template slot-scope="scope">
                                                        <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="reformPriceRmb"
                                                        :show-overflow-tooltip="true"
                                                        min-width="90"
                                                        label="总单台加价(元)">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specificReform"
                                                        :show-overflow-tooltip="true"
                                                        min-width="180"
                                                        label="改制要求">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">{{scope.row.specificReform}}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        :show-overflow-tooltip="true"
                                                        min-width="180"
                                                        label="备注">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">
                                                            {{scope.row.remark}}
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="cuname"
                                                        width="90"
                                                        label="创建人">
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div v-if="OtherTable.length > 0" style="width: 95%">
                                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                <h1>占用他人预测库存信息</h1>
                                            </div>
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="OtherTable"
                                                    stripe
                                                    border
                                                    max-height="500"
                                                    style="width: 100%;margin-left: 2%">
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="id"
                                                        width="160"
                                                        :show-overflow-tooltip="true"
                                                        label="预测编码">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="country"
                                                        width="90"
                                                        :show-overflow-tooltip="true"
                                                        label="国家名称">
                                                    <template slot-scope="scope">
                                                        <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proModel"
                                                        width="140"
                                                        :show-overflow-tooltip="true"
                                                        label="型号">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proCode"
                                                        width="120"
                                                        :show-overflow-tooltip="true"
                                                        label="产品编码">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="protype"
                                                        width="90"
                                                        label="型号属性"
                                                        :show-overflow-tooltip="true">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proNumber"
                                                        width="60"
                                                        :show-overflow-tooltip="true"
                                                        label="数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="useNumber"
                                                        :show-overflow-tooltip="true"
                                                        width="100"
                                                        label="可录单数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="useInventory"
                                                        width="120"
                                                        :show-overflow-tooltip="true"
                                                        label="使用库存数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isSpecific"
                                                        width="110"
                                                        :show-overflow-tooltip="true"
                                                        label="常规或改制">
                                                    <template slot-scope="scope">
                                                        <dictname category="shifou_dingzhi"  :v="scope.row.isSpecific"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="reformPriceRmb"
                                                        :show-overflow-tooltip="true"
                                                        min-width="90"
                                                        label="总单台加价(元)">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">{{scope.row.reformPriceRmb}}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specificReform"
                                                        :show-overflow-tooltip="true"
                                                        min-width="180"
                                                        label="改制要求">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">{{scope.row.specificReform}}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        :show-overflow-tooltip="true"
                                                        min-width="180"
                                                        label="备注">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">
                                                            {{scope.row.remark}}
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="stockStatus"
                                                        width="90"
                                                        label="库存状态">
                                                    <template slot-scope="scope">
                                                        <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="cuname"
                                                        width="90"
                                                        label="创建人">
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div v-if="ybTable.length > 0" style="width: 95%">
                                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                <h1>占用预排信息</h1>
                                            </div>
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="ybTable"
                                                    stripep
                                                    border
                                                    max-height="500"
                                                    style="width: 100%;margin-left: 2%">
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="id"
                                                        width="160"
                                                        :show-overflow-tooltip="true"
                                                        label="预测编码">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="country"
                                                        width="90"
                                                        :show-overflow-tooltip="true"
                                                        label="国家名称">
                                                    <template slot-scope="scope">
                                                        <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proModel"
                                                        width="140"
                                                        :show-overflow-tooltip="true"
                                                        label="型号">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proCode"
                                                        width="160"
                                                        :show-overflow-tooltip="true"
                                                        label="产品编码">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="protype"
                                                        width="90"
                                                        label="型号属性"
                                                        :show-overflow-tooltip="true">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="proNumber"
                                                        width="60"
                                                        :show-overflow-tooltip="true"
                                                        label="数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="useNumber"
                                                        :show-overflow-tooltip="true"
                                                        width="100"
                                                        label="剩余数量">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        :show-overflow-tooltip="true"
                                                        min-width="180"
                                                        label="备注">
                                                    <template slot-scope="scope">
                                                        <div style="text-align: left;">
                                                            {{scope.row.remark}}
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="cuname"
                                                        label="创建人">
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>

                        <div class="h-pieceTitle2" v-if="this.moreCondition" style="margin-bottom: 0.3rem;">
                            <h1>采购信息</h1>
                        </div>
                        <div class="h-row h-mrt0"  v-if="this.moreCondition" style="margin-top: 0.3rem!important;">
                            <div class="h-rowIn">
                                <div class="h-rowBox wxshenhe">
                                    <el-form
                                            :model="zy"
                                            label-position="right"
                                            ref="form1"
                                            :rules="rules"
                                            :inline="true"
                                            class="demo-ruleForm h-formbLine h-formbLine1">
                                        <div class="h-rowCon">


                                            <div class="h-pieceIn2">
                                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                    <h1>基本信息</h1>
                                                </div>
                                                <div class="h-pieceCon2">
                                                    <div class="h-formLine dingdan2">
                                                        <el-form-item label="订单总价" class="h-elformWrap-2">
                                                            <el-input readonly placeholder="自带出" v-model="zy.totalPrice"
                                                                      type="number"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="期望到货时间" class="h-elformWrap-2" prop="expectDate">
                                                            <div class="block">
                                                                <el-date-picker
                                                                        v-model="zy.expectDate"
                                                                        type="date"
                                                                        value-format="yyyy-MM-dd"
                                                                        placeholder="--选择--">
                                                                </el-date-picker>
                                                            </div>
                                                        </el-form-item>
                                                        <el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseOrgCode">
                                                            <el-select v-model="zy.purchaseOrgCode" :title="zy.purchaseOrgCode" remote
                                                                       clearable placeholder="请输入" @change="changeCgGroup">
                                                                <el-option v-for="(item,index) in purchastList"
                                                                           :key="item.code"
                                                                           :label="item.name"
                                                                           :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item label="采购组" class="h-elformWrap-2" prop="cgGroupCode">
                                                            <mdmselect
                                                                    clearable
                                                                    category="YLPurchaseGroup"
                                                                    :v="zy.cgGroupCode"
                                                                    disabled
                                                                    v-model="zy.cgGroupCode">
                                                            </mdmselect>
                                                        </el-form-item>
                                                        <el-form-item label="收货仓库" prop="warehouse" v-if="ckFlag" class="h-elformWrap-2">
                                                            <el-select v-model="zy.warehouse" :clearable="true" @change="changeWarehouse"
                                                                       placeholder="请选择">
                                                                <el-option label="青岛库" value="青岛库"></el-option>
                                                                <el-option label="苏州库" value="苏州库"></el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="h-pieceIn2">
                                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                                    <h1>物流信息</h1>
                                                </div>
                                                <div class="h-pieceCon2">
                                                    <div class="h-formLine dingdan2">
                                                        <el-form-item label="物流类型" class="h-elformWrap-2" prop="waybillType">
                                                            <el-select
                                                                    v-model="zy.waybillType"
                                                                    placeholder="请选择">
                                                                <el-option
                                                                        v-for="(item,index4) in options1"
                                                                        :key="index4"
                                                                        :label="item.name"
                                                                        :value="item.code">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item label="接收人" class="h-elformWrap-2" prop="receiver">
                                                            <el-input placeholder="请输入" v-model="zy.receiver"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="接收人手机号" class="h-elformWrap-2" prop="receverPhone">
                                                            <el-input placeholder="请输入" v-model="zy.receverPhone"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="收货单位" class="h-elformWrap-2" prop="receiveUnit">
                                                            <el-input placeholder="请输入" v-model="zy.receiveUnit"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="收货地址" class="h-elformWrap-2" prop="detailAddress">
                                                            <el-input clearable v-model="zy.detailAddress" readonly
                                                            >
                                                                <i
                                                                        class="el-icon-search el-input__icon"
                                                                        slot="suffix"
                                                                        @click="selectAreadialog">
                                                                </i>
                                                            </el-input>
                                                        </el-form-item>
                                                        <el-button class="h-btn h-bBtn h-bgblueQ2"
                                                                   @click="saveDefault()">保存默认信息
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="N-chan">
                                                <div class="h-pieceTitle2">
                                                    <h1>型号信息</h1>
                                                </div>
                                                <div class="yxtable ljjtable ljjtablepaddings6">
                                                    <el-table
                                                            ref="multipleTable"
                                                            :data="tableData3"
                                                            border
                                                            style="width: 100%"
                                                    >
                                                        <el-table-column
                                                                type="index"
                                                                width="40"
                                                                label="#">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="productCate"
                                                                label="产品大类"
                                                                width="140">
                                                            <template slot-scope="scope">
                                                                {{scope.row.productCate | dictname('product_level')}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="productDes"
                                                                label="产品型号"
                                                                width="240">
                                                            <template slot-scope="scope">
                                                                <div style="text-align: left;">
                                                                    {{scope.row.productDes}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="oemDesc"
                                                                label="规格型号"
                                                                width="240">
                                                            <template slot-scope="scope">
                                                                <div style="text-align: left;">
                                                                    {{scope.row.oemDesc}}
                                                                </div>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="productNo"
                                                                label="产品编码"
                                                                width="180">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="suserCode"
                                                                label="供应商名称"
                                                                width="240"
                                                        >
                                                            <template slot-scope="scope">

                                                                <el-select
                                                                        style="width: 100%;"
                                                                        class="h-tableInput"
                                                                        v-model="scope.row.suserCode"
                                                                        placeholder="请选择"
                                                                        filterable
                                                                        @change="changeSup(scope.row)">
                                                                    <el-option
                                                                            v-for="(item,index3) in scope.row.options2"
                                                                            :key="index3"
                                                                            :label="item.finalSupplierName"
                                                                            :value="item.finalSupplier">
                                                                    </el-option>
                                                                </el-select>

                                                            </template>

                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="unitPrice"
                                                                label="产品单价"
                                                                width="140">
                                                            <template slot-scope="scope">
                                                                <el-input class="h-tableInput" readonly placeholder="自带出" v-model="scope.row.unitPrice">
                                                                    {{ scope.row.unitPrice = (scope.row.specialPrice!=null?scope.row.specialPrice:scope.row.unitPrice) }}
                                                                </el-input>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="currency"
                                                                label="币种"
                                                                width="110"
                                                                :show-overflow-tooltip="true">
                                                            <template slot-scope="scope">
                                                                {{scope.row.currency | dictname('YLCurrency')}}
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="specialPrice"
                                                                label="产品特价"
                                                                min-width="140"
                                                        >
                                                            <template slot-scope="scope">
                                                                <el-select
                                                                        style="width: 100%;"
                                                                        v-model="scope.row.specialOfferCode"
                                                                        placeholder="请选择"
                                                                        @change="changeTejia($event,scope.row)"
                                                                        clearable>
                                                                    <el-option
                                                                            v-for="(item,index3) in scope.row.options2"
                                                                            :key="index3"
                                                                            :label="item.proDiscPrice"
                                                                            :value="item.sid">
                                                                    </el-option>
                                                                </el-select>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="avaiNumber"
                                                                label="特价余量"
                                                                width="130">
                                                            <template slot-scope="scope">
                                                                <el-input readonly placeholder="自带出"
                                                                          v-model="scope.row.avaiNumber"></el-input>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="Ycount"
                                                                label="产品数量"
                                                                width="130">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="Ycountry"
                                                                label="国家名称"
                                                                width="120"
                                                                :show-overflow-tooltip="true">
                                                            <template slot-scope="scope">
                                                                <dictname category="YLCountry_agent"  :v="scope.row.Ycountry"/>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="Ycuname"
                                                                label="预测人"
                                                                width="100"
                                                                :show-overflow-tooltip="true">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="Yid"
                                                                label="预测单编号"
                                                                width="200"
                                                                :show-overflow-tooltip="true">
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="Yhgetdate"
                                                                label="期望送货日期"
                                                                width="300">
                                                            <template scope="scope">
                                                                <el-date-picker
                                                                        v-model="scope.row.Yhgetdate"
                                                                        type="date"
                                                                        class="h-tableInput"
                                                                        value-format="yyyy-MM-dd">
                                                                </el-date-picker>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="Yremark"
                                                                label="备注"
                                                                width="300">
                                                            <template slot-scope="scope">
                                                                <el-input
                                                                        v-model="scope.row.Yremark"
                                                                        placeholder="备注"
                                                                        class="h-tableInput"
                                                                >
                                                                </el-input>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                                prop="productDetail"
                                                                label="物料描述"
                                                                :show-overflow-tooltip="true"
                                                                width="200">
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </div>
                                        </div>
                                    </el-form>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="h-table h-mrt30 h-rowBox" v-if="showText" style="margin-top: 0.2rem;">
                        <div class="h-pieceTitle2 hang">
                            <h1 class="h1">审批意见</h1>
                            <el-form :model="formLabelAlign" label-position="right" :inline="true"
                                     class="demo-ruleForm h-formbLine">
                                <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                              style="margin:30px 0 40px 29px">
                                    <el-input v-model="shenhetext" placeholder="请输入"
                                              class="zidaoO"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <div class="h-txtCenter h-mrt60">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                        <el-button v-if="showrefuse" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                        <el-button v-if="showpass" class="h-btn h-bBtn h-bggreen" @click="auditPass('form1')">通过</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="findDetail">查看审批详情</el-button>
                    </div>
                </div>
            </div>

        </div>

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

        <areaSelect
                :visible.sync="showdizhiflag"
                v-if="showdizhiflag"
                @choseObj="choseDizhi"
        />

    </div>
</template>
<script>

    import ss from '../../../../api/SystemService';
    import util from "../../../../utils/util";
    import big from 'big.js';
    // import wxxiangqingCheck from '../../../../views/loud/yuce/wxxiangqing/wxxiangqingCheck'

    export default {
        components: {},
        data() {
            return {
                orderNumber:'',
                tableData: [],
                formLabelAlign:{},
                tableData3: [],
                options: [],
                options2: [],
                multipleSelection: [],
                gyData: [],
                shenhetext:'',
                instid: '',
                u: '',
                k: 2,
                y: '',
                jj: '',
                cjcg: false,
                showhistory: false,
                showrefuse: false,
                showpass: false,
                showText: false,
                showdizhiflag: false,
                moreCondition: false,
                options1: [{
                    code: '2',
                    name: '外部物流'
                }],
                rules: {
                    waybillType: [
                        {required: true, message: '请选择物流类型', trigger: 'change'}
                    ],
                    expectDate: [
                        {required: true, message: '请选择期货时间', trigger: 'change'},
                    ],
                    receiveUnit: [
                        {required: true, message: '请输入收货单位', trigger: 'blur'}
                    ],
                    receiver: [
                        {required: true, message: '请输入接收人', trigger: 'blur'}
                    ],
                    receverPhone: [
                        {required: true, message: '请输入接收人手机号', trigger: 'blur'},
                        {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/,
                            message: '请输入正确的手机号'
                        }
                    ],
                    detailAddress: [
                        {required: true, message: '请输入收货地址', trigger: 'blur'}
                    ],
                    cgGroupCode: [
                        {required: true, message: '请选择采购组', trigger: 'blur'}
                    ],
                    purchaseOrgCode: [
                        {required: true, message: '请选择采购组织', trigger: 'blur'}
                    ],
                },
                zy: {
                    numlist: null,
                    receiver: '',
                    receiveUnit: '生物医疗',
                    suserCode: '',
                    productCate: '',
                    type: '',
                    productNo: '',
                    waybillType: '2',
                    unitPrice: '',
                    count: '',
                    totalPrice: '',
                    detailAddress: '青岛市城阳区华东路海尔生物医疗新兴产业园',
                    expectDate: '',
                    productCateName: '',
                    productDes: '',
                    suserName: '',
                    status: 0,
                    proId: '',
                    cgGroupCode: '',
                    province: '',
                    city: '',
                    country: '',
                    purchaseOrgCode:"",
                    ycId:'',
                    receverPhone:null,
                    warehouse:null,
                },
                table: {
                    data: [],
                    orderCg: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                    instId: ''
                },
                q: {
                    id: '',
                    taskId: ''
                },
                multipleSelectioncopy:[],
                disabled:false,
                disabled1:false,
                fajl: false,
                bzcs: false,
                purchastList:[],
                saveData:{
                    id:'',
                    productModel:'',
                    area:null,
                    isReal:'',
                    ypIds:[],
                    isOther:'',
                    otherNumber:0,
                    ypNumber:0,
                    oneNumber:0,
                    otherUseIds:[],
                    useOtherData:[],
                    deliveryMethod:'',
                    isReformStock:null,
                    reformEdition:null,
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:0,
                    useNumber:0,
                    useInventory:0,
                    useData:'',
                    proModel:'',
                    proCode:'',
                    country:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    otherYcReformPrice:0,
                    specific:'',
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:'',
                    useId:'',
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                    fileUrl:[],
                    isLk: 0,
                    lkYcId: '',
                    isStandard: '',
                    receivingAddress: '',
                    oemDesc: '',
                    factory:'',
                    specificList: [{
                        specificId: '',//改制id
                        specificDivision: '',//改制目录
                        specificReform: '',//改制要求
                        reformPrice: '',//单台加价
                        reformPriceJs: '',//系统计算单台加价
                        specificType:'',////1目录内改制 2目录外外改制
                        reformNum:1,//改制数量
                        specificRemark:'',
                    }],
                    proModelCode:'',
                    //型号经理录入 （个性化定制标准描述）
                    individualizeList:[''],
                    //型号经理录入 (包装标识要求)
                    logoRequestList:[''],
                    reformType:null,
                    stationlist:[],
                    reformMainDetailList:[],
                    useMeg:'',
                    isScheduling:'',
                    materialStation: '',
                    individualizeReform: '',
                    logoRequest:'',
                    produceTime:'',
                    checkRequest:'',
                    //是否是工艺审批节点
                    isgy :false,
                    // 产值(元)
                    outputValue:null,
                    // 标准台
                    standardTable:null,
                    grossProfitRate:null
                },
                f: {
                    productModel: '',
                    productCode: ''
                },
                ycTable:[],
                OtherTable:[],
                ybTable:[],
                areaList:[],
                lkFlag:false,
                afterXhFlag:false,
                gjCo:[],
                cwUpdateFlag:true,
                showIn:true,
                isshowtip:false,
                ckFlag:false,
            }
        },
        mounted() {

        },
        watch: {
            'saveData.specificList': {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    //计算总金额
                    // this.f.reformPrice = _.reduce(_.map(newValue, "reformPrice"), function (sum, v) {
                    //     return new big(sum).plus(v||0).toString();
                    // }, 0)
                    var reformPrice = 0;
                    for(var i = 0;i<newValue.length;i++){
                        reformPrice += newValue[i].reformPrice * newValue[i].reformNum||0;
                    }
                    this.saveData.reformPriceRmb = reformPrice + this.saveData.otherYcReformPrice; //定制加价 + 占用其他预测加价
                },
            },
        },
        created() {
            if (this.$route.query.taskstatus && this.$route.query.taskstatus == 1) {
                // TODO 跳转去查看页面也需要新加一个页面  因为拿到的是详情表的id  不再是主表id了
                this.$router.push({
                    path: "/yuce/yuceXiangqing",
                    query: {
                        ywid: this.$route.query.ywid,
                        instid: this.$route.query.instid,
                        taskid: this.$route.query.taskid,
                        shenpi: true,
                    }
                })
            }
            this.table.taskId = this.$route.query.taskid;
            this.table.instId = this.$route.query.instid;
            this.instid = this.$route.query.instid;
            if (this.$route.query.taskstatus == 0) {
                this.showrefuse = true;
                this.showpass = true;
                this.showText = true;
            }
            if (this.$store.getters.hasRole('swyl_waixiaogly')) {
                this.u = 1;
            }
            if (this.$store.getters.hasRole('swyl_wxcggly')) {
                // this.u = 1;
                this.cjcg = true;
            }
            if (this.$store.getters.hasRole('swyl_projl')) {
                this.k = 1;
            }
            if (this.$store.getters.hasRole('swyl_gzdshow')) {
                this.y = 1;
            }
            if (this.$store.getters.hasRole('swyl_cwrenyuan')) {
                this.jj = 1;
                this.cwUpdateFlag = false;
            }
            //获取物料工位
            this.options = this.$store.getters.dictlist("material_station");
            this.query();
            this.getCgDefault();
            // this.selectGY();
            this.checkXhSp(this.table.taskId);
        },
        methods: {
            checkOpen(data){
                let self = this;
                self.$refs["mychild2"].isShowDia(data,true);
                self.saveData = data;
            },
            // getSend(){
            //     var form = {};
            //     form.productId = this.tableData[0].proCode;
            //     ss.waixiao.getSendType(form).then(rd => {
            //         if(rd.length !=0 && rd[0].sendType=="3"){
            //             this.cjcg = false;
            //         }
            //     });
            // },
            //判断当前登录人是否是总部人员
            isGroup(){
                var form = {};
                form.spId = this.table.instId;
                ss.waixiao.isGroupMarket(form).then(rd => {
                    this.disabled = rd;
                    if(!rd){
                        for(var i=0;i<this.tableData.length;i++){
                            if(!this.tableData.isScheduling || this.tableData.isScheduling==null ||
                                this.tableData.isScheduling ==''){
                                this.disabled = false
                            }else {
                                this.disabled = true;
                                this.disabled1 = true;
                            }
                        }
                    }
                });
            },
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.input=e.target.value
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                // if (this.moreCondition == true) {
                this.tableData3 = [];
                var vid = [];
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    vid.push(this.multipleSelection[i].id);
                }
                if (vid.length > 0) {
                    this.wxycload(vid);
                }
                // }
            },
            chooseModify() {
                if (this.moreCondition) {
                    this.tableData3 = [];
                    var vid = [];
                    console.log("this.saveData.id",this.saveData)
                    vid.push(this.saveData.id);
                    console.log("vid",vid)
                    if (vid.length > 0) {
                        this.wxycload(vid);
                    }
                }
            },
            //构造参数
            gouzaocanshu() {

                var entitylist = [];

                for (var c in this.tableData3) {

                    entitylist.push({

                        numlist: this.zy.numlist,
                        type: this.zy.type,
                        waybillType: this.zy.waybillType,
                        detailAddress: this.zy.detailAddress,
                        expectDate: this.zy.expectDate,
                        status: this.zy.status,
                        cgGroupCode: this.zy.cgGroupCode,
                        purchaseOrgCode: this.zy.purchaseOrgCode,
                        province: this.zy.province,
                        city: this.zy.city,
                        country: this.zy.country,
                        receiver: this.zy.receiver,
                        receverPhone: this.zy.receverPhone,
                        receiveUnit: this.zy.receiveUnit,
                        warehouse: this.zy.warehouse,

                        instid: this.instId || null,
                        cgId: this.tableData3[c].cgId || '',
                        zhubiaoid: this.tableData3[c].zhubiaoid || '',
                        productCateName: this.$getDictName("product_level",this.tableData3[c].productCate),
                        productDes: this.tableData3[c].productDes,
                        productCate: this.tableData3[c].productCate,
                        productNo: this.tableData3[c].productNo,
                        suserCode: this.tableData3[c].suserCode,
                        suserName: this.tableData3[c].suserName,
                        unitPrice: this.tableData3[c].unitPrice,
                        count: this.tableData3[c].Ycount,
                        proId: this.tableData3[c].proId,
                        currency: this.tableData3[c].currency,
                        // totalPrice:new big(this.tableData3[c].unitPrice).times(this.tableData3[c].Ycount),
                        totalPrice:new big(parseFloat(this.tableData3[c].unitPrice)).times(parseInt(this.tableData3[c].Ycount)),
                        //预测单号c
                        ycId: this.tableData3[c].Yid,
                        ycountry: this.tableData3[c].Ycountry,
                        ycuname: this.tableData3[c].Ycuname,
                        yremark: this.tableData3[c].Yremark,
                        yhgetdate: this.tableData3[c].Yhgetdate,
                        oemDesc: this.tableData3[c].oemDesc,
                        sid: this.tableData3[c].sid,
                        avaiNumber: this.tableData3[c].avaiNumber,
                    })
                    console.log("111111111111",entitylist)
                }

                return entitylist;

            },
            changeNum(v) {
                var total=0;
                for(var i=0;i<this.tableData3.length;i++){
                    var data = this.tableData3[i];
                    if(data.count && data.unitPrice){
                        total=new big(data.Ycount).times(data.unitPrice).plus(total);
                    }
                }
                this.zy.totalPrice = total;
            },
            choseDizhi(obj) {
                this.zy.detailAddress = obj.quobj.namepath;
                if (obj.zhenobj) {
                    this.zy.detailAddress = obj.zhenobj.namepath;
                }
                this.zy.detailAddress = this.zy.detailAddress + obj.addrdetail;
                this.zy.province = obj.shengobj.name;
                this.zy.city = obj.shiobj.name;
                this.zy.country = obj.quobj.name;
                this.showdizhiflag = false;
            },
            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            addUseId() {
                var v = this.saveData;
                if (!v.useData || v.useData == '') {
                    v.zid = '';
                }
                v.useId = '';
                if (v.useData && v.useData.length != 0 && v.uids && v.uids.length != 0) {
                    for (var i = 0; i < v.useData.length; i++) {
                        for (var j = 0; j < v.uids.length; j++) {
                            if (v.useData[i] == v.uids[j].name) {
                                if (v.useId && v.useId != '') {
                                    v.useId = v.useId + v.uids[j].code + ","
                                } else {
                                    v.useId = v.uids[j].code + ","
                                }
                            }
                        }
                    }
                }
                if (v.zid && v.zid != '') {
                    v.useId = v.zid + v.useId;
                }
            },
            //查看审批流详情
            findDetail() {
                this.showhistory = true;
            },
            query() {
                this.q.id = this.$route.query.ywid;
                this.q.taskId = this.$route.query.taskid;
                // ss.waixiao.showSPList(this.q).then(rd => {
                //判断是否创建采购单
                if(this.q.id) {
                    ss.waixiao.isNeedCreateCg(this.q).then(rd => {
                        if(rd.f){
                            this.moreCondition = rd.obj && this.cjcg;
                        }else{
                            this.$msg.msge("系统异常，无法判断是否需要创建采购单！");
                        }
                    });
                }
                ss.waixiao.showNewSPList(this.q).then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        rd[i]['useData'] = [];
                        rd[i]['uids'] = [];
                        rd[i]['zid'] = '';
                    }
                    this.saveData = rd[0];
                    ///物料工位
                    this.saveData.stationlist = this.saveData.materialStation? this.saveData.materialStation.split(","): [];
                    //个性化定制标准描述
                    this.saveData.individualizeList = this.saveData.individualizeReform? this.saveData.individualizeReform.split("##"): [''];
                    //包装标识要求
                    this.saveData.logoRequestList = this.saveData.logoRequest? this.saveData.logoRequest.split("##"): [''];


                    if(this.saveData.isReal == 1){
                        this.saveData.isReal = "1";
                    }else if(this.saveData.isReal == 0){
                        this.saveData.isReal = "0";
                    }

                    if(this.saveData.isOther == 1){
                        this.saveData.isOther = "1";
                        this.showIn = false;
                    }else if(this.saveData.isOther == 2){
                        this.saveData.isOther = "2";
                        this.showIn = false;
                    }else {
                        this.showIn = true;
                    }

                    if(this.saveData.deliveryMethod == 1){
                        this.saveData.deliveryMethod = "1";
                    }else if(this.saveData.deliveryMethod == 2){
                        this.saveData.deliveryMethod = "2";
                    }
                    if(this.saveData.isLk == 1){
                        this.lkFlag = true;
                    }else {
                        this.lkFlag = false;
                    }

                    this.tableData = rd;

                    this.getPurchaseList();
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (this.tableData[i].useMeg && this.tableData[i].useMeg != '') {
                            //循环设置
                            this.tableData[i].useData = _.split(this.tableData[i].useMeg || [], ",");
                        }
                        if (this.tableData[i].useId && this.tableData[i].useId != '') {
                            this.tableData[i].zid = this.tableData[i].useId;
                        }
                        console.log('this.tableData[i].isLk',this.tableData[i].isLk)
                        if(this.tableData[i].isLk == 1){
                            this.fajl = true;
                            console.log('this.fajl',this.fajl)
                        }
                        if(this.tableData[i].isStandard == 2){
                            this.bzcs = true;
                        }
                    }
                    this.zy.expectDate = this.tableData[0].deliveryDate;
                    var vid = [];
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.selectStock(this.tableData[i]);
                        vid.push(this.tableData[i].id);
                    }
                    if(this.moreCondition){
                        this.chooseModify();
                    }
                    this.isGroup();
                    this.selectStockOther(this.tableData[0].proCode);
                    this.selectStockOtherPre(this.tableData[0].proCode);
                    // this.showCountry(this.saveData);
                })
            },
            newQw() {
                this.q.id = this.$route.query.ywid;
                this.q.taskId = this.$route.query.taskid;
                ss.waixiao.showNewSPList(this.q).then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        rd[i]['useData'] = [];
                        rd[i]['uids'] = [];
                        rd[i]['zid'] = '';
                    }
                    this.tableData = rd;
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (this.tableData[i].useMeg && this.tableData[i].useMeg != '') {
                            //循环设置
                            this.tableData[i].useData = _.split(this.tableData[i].useMeg || [], ",");
                        }
                        if (this.tableData[i].useId && this.tableData[i].useId != '') {
                            this.tableData[i].zid = this.tableData[i].useId;
                        }
                    }
                    var vid = [];
                    for (var i = 0; i < this.tableData.length; i++) {
                        this.selectStock(this.tableData[i]);
                        vid.push(this.tableData[i].id);
                    }
                    this.tableData3 = [];
                    // this.wxycload(vid);
                    if (!this.tableData || this.tableData.length < 1) {
                        //跳转回系统的代办列表
                        this.$router.push({path:'/personal/dealCenter'})
                    }
                })
            },
            selectStock(v) {
                var obj= {
                    proCode: v.proCode,
                    cucode: v.cucode
                }
                ss.waixiao.selectSPStock(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            v.uids.push({
                                code: rd[i].id,
                                name: rd[i].strDes,
                            });
                        }
                    }
                })
            },
            // selectGY(v) {
            //     ss.waixiao.selectGYuser().then(rd => {
            //         if (rd && rd.length > 0) {
            //             for (var i = 0; i < rd.length; i++) {
            //                 this.gyData.push({
            //                     code: rd[i].usercode,
            //                     name: rd[i].username,
            //                 });
            //             }
            //         }
            //     })
            // },
            wxycload(vd) {
                ss.waixiao.showDingdlist(vd).then(rd => {
                    if (rd && rd.length > 0) {
                        for (var i = 0; i < rd.length; i++) {
                            if (rd[i].protype!=null && rd[i].protype=="OEM"){
                                // this.zy.receiver = rd[i].cuname;
                                var data = {
                                    "productCate":rd[i].cpdlName,
                                    "productNo":rd[i].proCode,
                                    "Ycount":rd[i].proNumber,
                                    "productOptions":[{id:rd[i].proCode,levelname:rd[i].proModel}],
                                    "Ycountry":rd[i].country,
                                    "Yid":rd[i].id,
                                    "Ycuname":rd[i].cuname,
                                    "Yremark":rd[i].remark,
                                    "Yhgetdate":rd[i].deliveryDate,
                                    "oemDesc":rd[i].oemDesc,
                                    "productDetail":rd[i].productDetail

                                };
                                this.changeSmail(data,1);
                                this.tableData3.push(data);
                            }
                        }
                    }
                })
            },
            changeSmail(v,flag) {
                v.unitPrice = '';
                this.zy.totalPrice = '';
                v.count = '';
                v.proId = '';
                //设置产品型号名称
                if (flag == 1) {
                    v.productOptions.forEach((item, index) => {
                        if (v.productNo == item.id) {
                            v.productDes = item.levelname;
                        }
                    })
                } else if (flag == 2) {
                    v.productOptions.forEach((item, index) => {
                        if (v.productDes == item.levelname) {
                            v.productNo = item.id;
                        }
                    })
                }

                // //暂时注释掉获取单价接口
                // var data = {mdmMaterialInfoPrice: {materialid: v, leltypecode: 3}}
                // ss.ProService.product2Detail(data).then(rd => {
                //     if (rd.obj && rd.obj.length > 0) {
                //         this.zy.unitPrice = rd.obj[0].mdmMaterialInfoPrice.value;
                //     } else {
                //         this.zy.unitPrice = '';
                //     }
                // })
                v.options2 = [];
                v.suserCode = '';
                v.suserName = '';
                this.vs = {};
                //获取供应商列表
                if (v.productNo) {
                    this.vs.productId = v.productNo;
                    ss.ProService.supplierByProductId(this.vs).then(rd => {
                        if (rd && rd.length > 0) {
                            //供应商信息
                            v.options2 = rd;
                            v.options2.forEach((item, index) => {
                                let canshu = {};
                                canshu.suserCode = item.finalSupplier;
                                canshu.productNo = v.productNo;
                                /*                                ss.orderCgService.selectProSupplier(canshu).then(rd => {
                                                                    console.log('我在这儿呀111', rd);
                                                                    //item.finalSupplierName = item.finalSupplierName + ',产品供应量占比: ' + rd.proportion;
                                                                })*/
                            })
                            console.log('我在这儿呀000', v.options2);

                            this.$set(v.options2, rd);
                        }
                    })
                }
            },
            //供应商名字
            changeSup(v) {
                var totalPrice = 0;
                v.options2.forEach((item, index) => {
                    if (v.suserCode == item.finalSupplier) {
                        v.suserName = item.finalSupplierName;
                        v.unitPrice = item.unitPrice;
                        v.proId = item.contractId;
                        v.currency = item.currency;
                        this.tableData3.forEach((elements,index)=>{
                            console.log(elements.unitPrice,"////////");
                            console.log(elements.Ycount,"////////");
                            // if (totalPrice == 0) {
                            //     totalPrice = elements.unitPrice * elements.Ycount;
                            totalPrice = new big(parseFloat(elements.unitPrice)).times(parseInt(elements.Ycount)).plus(totalPrice);
                            // } else {
                            //     totalPrice = totalPrice + (elements.unitPrice * elements.Ycount);
                            // }
                        })
                    }
                })
                this.zy.totalPrice = totalPrice.toString();
            },
            auditPass(formName) {
                // 工艺节点判断是否填写 【产值(元)】、【标准台】
                if(this.saveData.isgy){
                    if (this.saveData.outputValue ===  null || this.saveData.outputValue === undefined) {
                        this.$msg.msge("请填写产值！");
                        return;
                    }
                    if (this.saveData.standardTable ===  null || this.saveData.standardTable === undefined) {
                        this.$msg.msge("请填写标准台！");
                        return;
                    }
                }
                var f = true;
                b:
                    if (this.u == 1) {
                        if(this.saveData.useData && this.saveData.useData != ''){
                            this.saveData.useMeg = _.join(this.saveData.useData || [], ",");
                        }else {
                            this.saveData.useId = '';
                            this.saveData.useMeg = '';
                        }

                    }
                if (f == true && this.moreCondition == true) {
                    if (this.tableData3.length < 1) {
                        this.$msg.msge("请选择要生成采购单的预测数据！");
                        return false;
                    }
                    m:
                        for (var i = 0; i < this.tableData3.length; i++) {
                            console.log(this.tableData3[i].suserCode,"???");
                            if (!this.tableData3[i].suserCode || this.tableData3[i].suserCode == '') {
                                this.$msg.msge("请选择供应商！");
                                return false;
                                break m;
                            }
                            if (!this.tableData3[i].unitPrice || this.tableData3[i].unitPrice == ''
                                || this.tableData3[i].unitPrice == 0) {
                                this.$msg.msge("产品单价不能为0或空！");
                                return false;
                                break m;
                            }
                        }
                    //判断下单数量与特价数量
                    var flagNum = false;
                    this.tableData3.forEach((item, index) => {
                        if (item.specialPrice && item.count > item.avaiNumber) {
                            flagNum = true;
                        }
                    })
                    var flag = 0;
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            console.log(1)
                        } else {
                            flag = flag + 1;
                            return false;
                        }
                    });
                    // console.log(flag)
                    if (flag !== 0) {
                        return false;
                    }
                }
                if (f) {
                    console.log(this.tableData,"///////////////");
                    this.table.aaa = 2
                    this.table.optflag = '审核通过';
                    this.table.yijianMsg = this.shenhetext;
                    this.table.data = [];
                    this.table.data.push(this.saveData);
                    if (this.moreCondition == true) {
                        this.zy.expectDate = util.riQi6(this.zy.expectDate)
                        this.zy.status = 0;
                        this.table.orderCg = this.gouzaocanshu();
                    } else {
                        this.table.orderCg = [];
                    }
                    console.log("审批通过啦!!!")
                    console.log(this.table,"啥玩意啊");
                    ss.waixiao.auditForecast(this.table).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            this.shenhetext = '';
                            this.multipleSelection = [];
                            this.tableData3 = [];
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})

                        } else {
                            this.$msg.msge(rd.msg);
                            this.shenhetext = '';
                            this.newQw();
                        }
                    })
                }
            },
            auditFail() {
                this.$msg.confirm("确认驳回? 若没有勾选要审核的数据，则会将所有的预测全部驳回！", () => {
                    var reg = /^\s$/;
                    if (reg.test(this.shenhetext)) {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    if (this.shenhetext == "") {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    this.table.aaa = 1
                    this.table.optflag = '审核被驳回';
                    this.table.yijianMsg = this.shenhetext;
                    this.table.data.push(this.saveData)
                    // ss.waixiao.shBTG(this.table).then(rd => {
                    ss.waixiao.auditForecast(this.table).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            this.shenhetext = '';
                            this.multipleSelection = [];
                            this.tableData3 = [];
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            // this.$router.push({path:'/personal/dealCenter'})
                            this.newQw();
                        } else {
                            this.$msg.msge(rd.msg);
                            this.shenhetext = '';
                            this.newQw();
                        }
                    })
                })
            },
            returnTable() {
                // this.$router.go(-1);
                this.$router.push({path: '/personal/dealCenter'})
            },
            checkUseInventory(val){
                let proNumber = parseInt(val.proNumber?val.proNumber:0);
                let useNumber = parseInt(val.useNumber?val.useNumber:0);
                let useInventory = parseInt(val.useInventory?val.useInventory:0);

                if(useInventory+useNumber>proNumber){
                    this.$msg.msge("使用库存数量+可录单数量不得大于预测数量!");
                    val.useInventory="";
                }

            },
            //获取采购默认值
            getCgDefault(){

                var data = {}
                data.purchaseOrgCode = this.zy.purchaseOrgCode;
                data.kuwei = this.zy.warehouse?this.zy.warehouse:"青岛库";

                ss.orderCgService.getDefaultCg(data).then(rd => {
                    if(rd.f){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                    }
                })
            },
            //保存采购默认参数
            saveDefault() {
                var saveData = {};
                saveData.receiver = this.zy.receiver;
                saveData.receiveUnit = this.zy.receiveUnit;
                saveData.receiverPhone = this.zy.receverPhone;
                saveData.receiveAddress = this.zy.detailAddress;

                if(this.ckFlag){
                    saveData.kuwei = this.zy.warehouse;
                    saveData.purchaseOrgCode = this.zy.purchaseOrgCode;
                }else {
                    saveData.kuwei = "青岛库";
                    saveData.purchaseOrgCode = "9OE1,9OE2,9OE3,1RK0,6XG1,1JC0,0PN1";
                }

                ss.orderCgService.saveCgDefault(saveData).then(rd=>{
                    if(rd.f){
                        this.getCgDefault();
                    }
                })
            },
            changeCgGroup(){
                var category = 'cg_org_group';
                var code = this.zy.purchaseOrgCode;
                //根据选中的采购组织编码获取采购组
                ss.Dictservice.getDictByCateCode(category,code).then(rd =>{
                    this.zy.cgGroupCode = rd.name;
                })
            },
            getPurchaseList(){
                var category = 'purchase_org_code';
                var des = this.tableData[0].factory;
                ss.Dictservice.listbycategoryanddes(category,des).then(rd=>{
                    this.purchastList = rd;
                    this.zy.purchaseOrgCode = this.purchastList[0].code;

                    if(this.zy.purchaseOrgCode == '1R60'){
                        this.ckFlag = true;
                    }else {
                        this.ckFlag = false;
                    }

                    this.getCgDefault();

                    this.changeCgGroup();
                })
            },
            dateFomatter(v){
                let dt = new Date(v)
                return this.$util.riQi3(dt);
            },
            //特价改变
            changeTejia(scode, row) {
                console.log('特价改变', scode, row)
                if (row.specialOfferCode) {
                    const tjobj = _.find(row.options2, {sid: row.specialOfferCode})
                    row.specialPrice = tjobj.proDiscPrice;
                    row.avaiNumber = tjobj.avaiNumber;
                    row.sid = tjobj.sid;
                } else {
                    row.specialOfferCode = null;
                    row.specialPrice = null;
                    row.avaiNumber = null;
                    row.sid = null;
                }
            },
            checkXhSp(taskid){
                ss.waixiao.checkXhSp(taskid).then(rd =>{
                    this.afterXhFlag = rd.msg;
                })
            },
            selectStockOther(v) {
                this.getOtherData=[];
                var obj= {
                    proCode: v
                }
                ss.waixiao.checkSelectStockOther(obj).then(rd => {
                    var list = this.tableData[0].otherUseId.split(",");
                    if (rd && rd.length > 0) {
                        this.getOtherData = rd;
                        for(var t=0;t<this.getOtherData.length;t++){
                            for(var i=0;i<list.length;i++){
                                if(this.getOtherData[t].id == list[i]){
                                    this.OtherTable.push(this.getOtherData[t]);
                                }
                            }
                        }
                    }
                })
            },
            selectStockOtherPre(v) {
                this.getypData=[];
                var obj= {
                    proCode: v
                }
                ss.waixiao.selectCheckPreList(obj).then(rd => {
                    var list = this.tableData[0].preId.split(",");
                    if (rd && rd.length > 0) {
                        this.getypData = rd;
                        for(var t=0;t<this.getypData.length;t++){
                            for(var i=0;i<list.length;i++){
                                if(this.getypData[t].id == list[i]){
                                    this.ybTable.push(this.getypData[t]);
                                }
                            }
                        }
                    }
                })
            },
            showCountry(data) {
                var country = this.$store.getters.dictlist("YLCountry_agent");
                ss.waixiao.selectCountry().then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        for (var j = 0; j < country.length; j++) {
                            if (country[j].code == rd[i]) {
                                this.gjCo.push(country[j].name);
                            }
                            if(country[j].code == data.country){
                                data.country = country[j].name;
                            }
                        }
                    }
                    this.clickmodel(data)
                })
            },
            inputOnMouseOver(event){
                const target=event.target
                if(target.offsetWidth<target.scrollWidth){
                    this.isshowtip=false
                }else{
                    this.isshowtip=true
                }
            },
            changeWarehouse(){
                var data = {}
                data.purchaseOrgCode = this.zy.purchaseOrgCode;
                data.kuwei = this.zy.warehouse;
                //获取默认收货信息
                ss.orderCgService.getDefaultCg(data).then(rd => {
                    if(rd.f){
                        this.zy.detailAddress = rd.msg.receiveAddress;
                        this.zy.receiver = rd.msg.receiver;
                        this.zy.receiveUnit = rd.msg.receiveUnit;
                        this.zy.receverPhone = rd.msg.receiverPhone;
                    }
                })
            },
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
    }
    .apprButton {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 0.3rem 0;
    }
    .cancel {
        width: 18%;
    }
    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }
    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }
    /*--------------- 审批样式 ------------------*/
</style>
<style>
    .wxshenhe .h-formbLine .h-elformWrap-2{
        width: 33.33%;
    }
    .wxshenhe .h-formbLine .el-form-item__label{
        width: 38%;
    }
    .wxshenhe .h-formbLine .el-form-item__content{
        width: 62%;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 25% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-5 {
        width: 74% !important;
        padding-right: 0.5rem
    }


    .Yangbiao .h-elformWrap-3 {
        width: 85% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-3 .el-form-item__label {
        width: 12%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-35 {
        width: 77% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .h-elformWrap-35 .el-form-item__label {
        width: 20%;
        text-align: right;
    }
    .Yangbiao .h-elformWrap-4 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-4 .el-form-item__label {
        width: 10%;
    }
    .Yangbiao .h-elformWrap-4 .el-form-item__content {
        width: 89%;
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }

    .ljjtablepaddings6 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings6 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .bbbb {
        padding-top: 5px;
        margin: 0 20px;
    }

    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }

</style>
